import { createSlice } from "@reduxjs/toolkit";
import { getListGiftExchangeForCustomerActive } from "../../api/giftExchange/giftExchange";

// giá trị khởi tạo của state
const initialState = {
  listGiftExchangeForCustomerActive: [],
  isLoadGiftExchangeForCustomerActive: false,
  currentPage: 1,
  pageSize: 8,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const giftExchangeForCusActiveSlice = createSlice({
  name: "giftExchangeForCusActive", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListGiftExchangeForCustomerActive.pending, (state) => {
        // api đnag pending chờ xử lý
        state.isLoadGiftExchangeForCustomerActive = true;
        state.error = null;
      })
      .addCase(getListGiftExchangeForCustomerActive.fulfilled, (state, action) => {
        // api trả về thành công thì trả ra
        
        state.isLoadGiftExchangeForCustomerActive = false;

        if (action.payload.current_page === 1) {
          state.listGiftExchangeForCustomerActive = action.payload.data || [];
        } else {
          state.listGiftExchangeForCustomerActive =
            [...state.listGiftExchangeForCustomerActive, ...action.payload.data] || [];
        }

        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListGiftExchangeForCustomerActive.rejected, (state, action) => {
        // api trả về thất bại thì trả ra
        state.isLoadGiftExchangeForCustomerActive = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  giftExchangeForCusActiveSlice.actions;
export default giftExchangeForCusActiveSlice.reducer;
